import React from 'react';
import {
  Link, useHistory,
} from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  AppBar, Toolbar, makeStyles, Grid, Typography, ButtonBase,
} from '@material-ui/core';

import PropTypes from 'prop-types';
import config, { maxWidth, domainTheme } from '../../config/config';
import HeaderLogin from './HeaderLogin';

const useStyles = makeStyles((theme) => ({
  preHeaderToolbar: {
    backgroundColor: theme.palette.primary.main,
    minHeight: 0,
    height: theme.spacing(3),
  },
  preHeaderToolbarContainer: {},
  preHeaderToolbarInner: {
    maxWidth,
    textAlign: 'right',
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
  toolbarInner: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth,
    width: '100%',
    alignItems: 'center',
  },
  toolbar: {
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    height: theme.spacing(8),
  },
  left: {
    flex: '0 0 305px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 140px',
    },
  },
  leftPHMAUR: {
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 120px',
    },
  },
  leftPHCHAMP: {
    [theme.breakpoints.down('xs')]: {
      flex: '0 0 120px',
    },
  },
  right: {
    flex: '0 0 140px',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  logoImage: {
    display: 'block',
    width: 183,
    [theme.breakpoints.down('xs')]: {
      width: 110,
    },
  },
  logoImageDEFAULT: {
    height: 35,
    [theme.breakpoints.down('xs')]: {
      height: 21,
    },
  },
  logoImagePHEST: {
    width: 305,
    [theme.breakpoints.down('xs')]: {
      height: 48,
      width: 'auto',
    },
  },
  logoImagePHCHAMP: {
    width: 305,
    [theme.breakpoints.down('xs')]: {
      height: 48,
      width: 'auto',
    },
  },
  logoImagePHMAUR: {
    width: 305,
    [theme.breakpoints.down('xs')]: {
      height: 48,
      width: 'auto',
    },
  },
  langSelected: {
    color: '#ffffff',
    textDecoration: 'underline',
    fontWeight: 'bold',
    lineHeight: 1.6,
  },
  langSeparator: {
    borderRight: '1px solid white',
    height: 10,
    margin: '5px 5px',
  },
  btnLang: {
    minWidth: 44,
    color: '#ffffff',
    textDecoration: 'none',
    lineHeight: 1.6,
  },
  btnLogin: {
    padding: '0 5px',
    margin: '0 30px',
    color: '#ffffff',
    fontSize: '14px',
  },
  contactNumber: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
}));

const HeaderBar = (props) => {
  const {
    location,
  } = props;
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();

  const theme = domainTheme(window.location.hostname);

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar className={classes.preHeaderToolbar}>
          <Grid
            className={classes.preHeaderToolbarContainer}
            container
            spacing={0}
            justifyContent="center"
          >
            <Grid
              className={classes.preHeaderToolbarInner}
              item
              xs={12}
            >
              <HeaderLogin />
              {config.LOCALES.map((locale) => {
                if (locale !== intl.locale) {
                  return (
                    <Typography component="span">
                      <Link
                        className={classes.btnLang}
                        color="inherit"
                        to={`/${locale}${location.pathname.slice(3)}`}
                        key={locale}
                        onClick={() => {
                          if (window && window.gtag) {
                            window.gtag('event', 'select_content', {
                              content_name: locale === 'en' ? 'In English' : 'En Français',
                              content_lang: intl.locale,
                            });
                          }
                        }}
                      >
                        {locale.toUpperCase()}
                      </Link>
                    </Typography>
                  );
                }
                return (
                  <Typography className={classes.langSelected} component="span">
                    {locale.toUpperCase()}
                  </Typography>
                );
              })
                .reduce((acc, x) => (acc === null ? x : (
                  <>
                    {acc}
                    <span className={classes.langSeparator} />
                    {x}
                  </>
                )), null)}
            </Grid>
          </Grid>
        </Toolbar>
        <Toolbar className={classes.toolbar}>
          <div className={classes.toolbarInner}>
            <div className={`${classes.left} ${classes[`left${theme.code}`]}`}>
              <ButtonBase
                onClick={() => {
                  history.push(`/${intl.locale}/`);
                  location.reload();
                }}
              >
                <img
                  className={`${classes.logoImage} ${classes[`logoImage${theme.code}`]}`}
                  src={theme.logo}
                  alt="Physio Extra"
                />
              </ButtonBase>
            </div>

            <div className={classes.right}>
              <div>
                <a
                  className={classes.contactNumber}
                  href={intl.formatMessage({ id: 'HeaderBar.telephoneNumberLink' })}
                >
                  <Typography variant="h6" component="span">
                    <FormattedMessage id="HeaderBar.telephoneNumber" />
                  </Typography>
                </a>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

HeaderBar.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    reload: PropTypes.func,
  }).isRequired,
};

export default HeaderBar;
